<template>
  <v-dialog
      v-model="dialog"
      persistent
      max-width="600"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          small
          icon
          v-bind="attrs"
          v-on="on"
          @click="onOpen()"
      >
        <v-icon small icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <v-sheet class="pt-5 px-3">
      <v-file-input
          v-model="file"
          :label="$t('columns.file')"
          counter
          show-size
          dense
          outlined
          clearable
          :disabled="!!direct_link"
          @change="onFileSelect(editedItem)"
      >
      </v-file-input>
      <v-text-field
          v-model="direct_link"
          :label="$t('columns.direct_link')"
          dense
          outlined
          @change="onDirectLinkSet()"
          :disabled="!!file"
      >
      </v-text-field>
<!--      <v-checkbox-->
<!--          v-model="editedItem.copy_to_store"-->
<!--          :label="$t('columns.copy_to_store')"-->
<!--          dense-->
<!--          outlined-->
<!--          @change="onDirectLinkSet()"-->
<!--          :disabled="!!file"-->
<!--      >-->
<!--      </v-checkbox>-->
    </v-sheet>
    <v-toolbar height="36">
      <v-spacer></v-spacer>
      <v-btn
          small
          @click="onCancel()"
      >
        {{ $t('cancel') }}
      </v-btn>
      <v-btn
          small
          class="ml-3"
          @click="onSave()"
          :loading="loading"
          :disabled="!file && !direct_link"
      >
        {{ $t('save') }}
      </v-btn>
    </v-toolbar>
    <ConfirmDialog :confirm_request="confirm_request" :fetch-request="fetchRequest"></ConfirmDialog>
  </v-dialog>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import fileFunction from "@/commonFunction/fileFunction";
import ConfirmDialog from "@/components/Base/ConfirmDialog";


export default {
  name: 'LibraryFileNewDialog',
  props: {
    value: {default: null},
    dto_detail_model: {type: [String], default: 'LibraryFileDetailQueryDTO'},
    dto_save_model: {type: [String], default: 'LibraryFileSaveCommandDTO'},
    icon: {type: [String], default: 'mdi-image-area'},
  },

  components: {
    ConfirmDialog,
  },

  computed: {
    ...mapFields('LibraryFileTable', ['editedItem', 'confirm_request', 'commandLoading', 'loading', 'itemUid']),
  },

  watch: {
    editedItem: {
      handler(newValue, oldValue) {
        // console.log('watch', newValue, oldValue)
        if (!!newValue.file_link) {
          this.$emit('input', newValue.file_link)
          this.dialog = false
        }
      },
      deep: true
    },
  },

  methods: {
    ...mapActions('LibraryFileTable', ['fetchItem', 'fetchSaveEditedItem', 'fetchRequest',]),

    onOpen() {
      console.log('onOpen')
      this.itemUid = uuidv4()
      this.file = null
      this.editedItem = {
        file: null,
        name: null,
        uid: this.itemUid,
        file_base64: null,
        copy_to_store: false,
      }
    },

    onCancel() {
      this.dialog = false
    },

    onSave() {
      // console.log("Save", this.editedItem, this.file)
      if (!!this.file)
        this.fetchSaveEditedItem(this.dto_save_model)
      else {
        this.$emit('input', this.direct_link)
          this.dialog = false
      }
    },

    async onFileSelect(editedItem) {
      if (!!this.file) {
        editedItem.file_base64 = await fileFunction.getBase64(this.file)
        editedItem.name = this.file.name
      } else {
        this.direct_link = null
        // editedItem.copy_to_store = false
      }
      // console.log('editedItem.file_base64', editedItem.file_base64)
    },
    onDirectLinkSet() {
      // console.log('onDirectLinkSet')
      if (!!this.editedItem && this.direct_link === '') this.direct_link = null
      if (!!this.editedItem && !this.direct_link) {
        this.file = null
        this.editedItem.file_base64 = null
        this.editedItem.name = null
      }
    },
  },

  async mounted() {
  }
  ,

  data() {
    return {
      dialog: false,
      file: null,
      direct_link: null,
    }
  }
}
</script>

<style>
</style>

<i18n>
{
  "en": {
    "columns": {}
  },
  "de": {
    "columns": {}
  }
}
</i18n>
